var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 75,
    viewBox: "0 0 118 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1052_66948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59 74.3969C91.3087 74.3969 117.5 68.7101 117.5 61.695C117.5 54.68 91.3087 48.9932 59 48.9932C26.6913 48.9932 0.5 54.68 0.5 61.695C0.5 68.7101 26.6913 74.3969 59 74.3969Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.047 24.9682L82.4987 4.09716C81.6084 2.67455 80.3086 1.81445 78.9394 1.81445H39.0606C37.6914 1.81445 36.3916 2.67455 35.5013 4.09535L16.9531 24.97V41.7347H101.047V24.9682Z",
    stroke: "#D9D9D9",
    strokeWidth: 0.63587
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5738 30.7218C76.5738 27.8094 78.3909 25.4051 80.645 25.4033H101.047V58.3139C101.047 62.1662 98.6338 65.3235 95.6539 65.3235H22.3461C19.3662 65.3235 16.9531 62.1644 16.9531 58.3139V25.4033H37.355C39.6091 25.4033 41.4262 27.804 41.4262 30.7163V30.7563C41.4262 33.6686 43.2635 36.0203 45.5158 36.0203H72.4842C74.7365 36.0203 76.5738 33.6468 76.5738 30.7345V30.7218Z",
    fill: "#FAFAFA",
    stroke: "#D9D9D9",
    strokeWidth: 0.63587
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1052_66948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 74.3967,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcon);
export default __webpack_public_path__ + "static/media/group_icon.c9831f4816da52aa299fd6916ef1896d.svg";
export { ForwardRef as ReactComponent };